import React, { useEffect, useRef, useState } from "react";
import SkeletonTable from "../Skeleton/SkeletonTable";

import "./cobranza.css";
import styles from "./cobranzaOther.module.css";

import { format } from "date-fns";

import CobranzaConciliacionClientesCell from "./CobranzaConciliacionClientesCell";
import { ConciliacionItemType } from "../../../../helper/const";

export default function CobranzaConciliacionTable({
  items,
  lastParcialInfo,
  cobranzaInfoDetail,
  openItem,
  openConvenio,
  handleDetail,
  handleSortChange,
  openEstadoCuenta,
  abonarCliente,
  abonarProducto,
  isLoading = false,
}) {
  const theadRef = useRef();

  const tDetalleRef = useRef([]);
  const tDetalleIsShownRef = useRef([]);
  //  const asociadosClientesRef = useRef({});
  //const [asociadosClientes, setAsociadosClientes] = useState({});

  const [areLoading, setAreLoading] = useState(false);

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    /*  const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }
  
    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });*/
  }

  /*async function toggleDetails(index, asociadoId) {
    console.log(items);
    if (tDetalleIsShownRef.current[index] == null) return;
    /*tDetalleRef.current[index].style.display = tDetalleIsShownRef.current[index]
      ? "none"
      : "flex";
    tDetalleIsShownRef.current[index] = !tDetalleIsShownRef.current[index]; /

    if (asociadosClientes[asociadoId] != null) {
      showClienteRow(index);
      return;
    }

    /*if (
      tDetalleIsShownRef.current[index] &&
      asociadosClientesRef.current[asociadoId] == null
    ) { /
    if (asociadosClientes[asociadoId] == null) {
      const response = await api.asociadoClientes(asociadoId).catch((error) => {
        toast.error("Error al pedir Niveles.");
        //setIsLoading(false);
      });
      asociadosClientes[asociadoId] = response.data.clientes;
      setAsociadosClientes({ ...asociadosClientes });

      showClienteRow(index);
    }
  }*/
  async function toggleDetails(index, asociadoId) {
    console.log(items);

    showClienteRow(index);
  }

  /*
  async function openModals(index, asociadoId) {
    console.log(items);

    showClienteRow(index);
  } */

  function showClienteRow(index) {
    //if (items[index].clientes.length === 0) {

    const item = items[index];
    let contentCount = 0;
    if (item.type === ConciliacionItemType.COBRANZA) {
      contentCount = item.ordenParcialidades.length;
    } else if (item.type === ConciliacionItemType.INTERES) {
      contentCount = item.other.length;
    }

    if (contentCount.length === 0) {
      //} == null) {
      tDetalleIsShownRef.current[index] = true;

      const newloading = !areLoading;
      setAreLoading(newloading);

      setTimeout(function () {
        handleDetail(index, () => {
          tDetalleRef.current[index].style.display = "flex";
          tDetalleIsShownRef.current[index] = true;
          setAreLoading(!newloading);

          generatePDF(null, items[index]);

          //  setAsociadosClientes({ index: index });
        });
      }, 200);

      /*  */
      return;
    }
    if (tDetalleIsShownRef.current[index] == null) return;

    //  setTimeout(function () {
    tDetalleIsShownRef.current.forEach((element, index) => {
      tDetalleIsShownRef.current[index] = false;
    });

    tDetalleIsShownRef.current[index] = !tDetalleIsShownRef.current[index];

    console.log(`--toreto ${index} ${tDetalleRef.current[index]} ++`);

    /*tDetalleRef.current[index].style.display = tDetalleIsShownRef.current[index]
      ? "none"
      : "flex";*/
    //}, 3000);

    setTimeout(function () {
      setAreLoading(!areLoading);
    }, 200);

    //generatePDF(null, items[index]);
  }

  function generatePDF(event, item) {
    //onGenerateTicket("b64", item);
    const item2 = {
      cliente: { nombre: "aq1", direcciones: [] },
      ordenVentaDetalles: [
        {
          asociado: { nombre: "rewerw" },
          cliente: { nombre: "aq1", direcciones: [] },
          producto: {
            nombre: "roundo",
          },
          precio: 234,
          cantidad: 2,
          total: 450,
        },
      ],
    };

    /*
  }]

    }

    item.ordenVentaDetalles
    .map(function (info) {
      const nombre = [
        {
          text: info.producto.nombre,
          style: "tProductsBody",
          colSpan: 4,
          lineHeight: 0,
        },
        {},
        {},
        {},
      ];

      const descripcion = [
        { text: info.cantidad, style: "tProductsBody", alignment: "center" },
        {
          text: "",
          style: "tProductsBody",
          alignment: "center",
        },
        {
          text: Singleton.getInstance().format(info.precio),
          style: "tProductsBody",
          alignment: "right",
        },
        {
          text: Singleton.getInstance().format(info.total),
          style: "tProductsBody",
          alignment: "right",
        },
      ];

      const re = [nombre, descripcion];

      return re;
    })
    .flatMap((info) => info);*/
    /*
  const total = Singleton.getInstance().format(item.totalVenta);
  const subTotal = Singleton.getInstance().format(item.subTotalVenta);
  const descuento = Singleton.getInstance().format("0.0");
  //const subTotalLetra = NumeroALetras(item.subtotal)
  const totalLetra = NumeroALetras(item.totalVenta, true);
  //"SON: SEISCIENTOS TREINTA MIL QUINIENTOS CINCO Y CINCO CON 00/100 PESOS",

  const asociadoNombre = buildName(item.asociado, true);
  const clienteNombre = buildName(item.cliente, true);
  let domicilioCliente = "---";
  if (item.cliente.direcciones.length > 0) {
    const address = item.cliente.direcciones[0];
    const infos = [
      address.calle,
      address.noExterior,
      address.colonia,
      address.cp,
      address.ciudad,
      address.estado,
    ];
    domicilioCliente = infos.join(", ");
  }*/

    //
    //onGenerateEstadoCuentaPDF("print", item);
  }

  useEffect(() => {
    tDetalleIsShownRef.current.length = 0;
    tDetalleIsShownRef.current = new Array(items.length).fill(false);

    tDetalleRef.current = new Array(items.length).fill("");
  }, [items]);

  let currentParcialidadDate =
    lastParcialInfo?.fechaInicio != null
      ? format(lastParcialInfo?.fechaInicio, "dd-MMM-yy")
      : "";

  return (
    <div className="row">
      {/*<h2>Outer Table with Inner Table</h2>*/}

      <table
        className="table table-borderless datable sortable table-hover table-fork"
        style={{ backgroundColor: "lightblue" }}
        width="100%"
      >
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr className={styles.has_tr}>
            <th
              scope="col"
              data-column="asociado.id"
              style={{
                width: "90px",
                verticalAlign: "middle",
              }}
              onClick={(event) => handleSort(event)}
            >
              Id
            </th>

            <th
              scope="col"
              data-column="asociado.nombre"
              style={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
              onClick={(event) => handleSort(event)}
            >
              Producto
            </th>

            <th
              scope="col"
              data-column="asociado.nombre"
              style={{
                textAlign: "center",
                width: "105px",
                verticalAlign: "middle",
              }}
              onClick={(event) => handleSort(event)}
            >
              <div>Fecha de Venta</div>
            </th>

            <th
              scope="col"
              data-column="asociado.nombre"
              style={{
                textAlign: "center",
                width: "105px",
                verticalAlign: "middle",
              }}
              onClick={(event) => handleSort(event)}
            >
              Precio
            </th>

            <th
              scope="col"
              data-column="asociado.nombre"
              style={{
                textAlign: "center",
                width: "105px",
                verticalAlign: "middle",
              }}
              onClick={(event) => handleSort(event)}
            >
              Plazo en quincenas
            </th>

            <th
              scope="col"
              data-column="asociado.nombre"
              style={{
                textAlign: "center",
                width: "105px",
                verticalAlign: "middle",
              }}
              onClick={(event) => handleSort(event)}
            >
              Abono quincenal
            </th>

            <th
              scope="col"
              data-column="asociado.credito"
              onClick={(event) => handleSort(event)}
              style={{
                width: "105px",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              No de abono
            </th>
            <th
              scope="col"
              data-column="asociado.credito"
              onClick={(event) => handleSort(event)}
              style={{
                width: "105px",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Total abonado
            </th>
            <th
              scope="col"
              data-column="asociado.credito"
              onClick={(event) => handleSort(event)}
              style={{
                width: "105px",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Total pendiente
            </th>
            <th
              scope="col"
              data-column="asociado.credito"
              onClick={(event) => handleSort(event)}
              style={{
                width: "105px",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Pago de la quincena
            </th>
            <th
              scope="col"
              data-column="asociado.credito"
              onClick={(event) => handleSort(event)}
              style={{
                width: "105px",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Comisión
            </th>

            <th
              scope="col"
              data-column="asociado.credito"
              onClick={(event) => handleSort(event)}
              style={{
                width: "105px",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Nuevo saldo al realizar pago
            </th>

            {/*<th
              scope="col"
              data-column="asociado.credito"
              onClick={(event) => handleSort(event)}
              style={{
                width: "150px",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              Abono Adicional
            </th>*/}
            <th
              scope="col"
              className="no-sort"
              data-column="asociado.credito"
              onClick={(event) => handleSort(event)}
              style={{
                width: "100px",
                textAlign: "center",
                verticalAlign: "middle",
              }}
            ></th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <SkeletonTable columnCount={13} rowCount={6} />}
          {!isLoading &&
            items.map((item, index) => {
              //const numCliente = cobranzaItem?.ordenVentaDetalle?.producto?.nombre ?? "-";

              /*    const displayDetalle = {
    display: tDetalleIsShownRef.current[index] ? "table-row" : "none",
  };*/

              let cobranzaItem =
                item.type === ConciliacionItemType.COBRANZA ? item : null;
              let interesesItems =
                item.type === ConciliacionItemType.INTERES ? item : null;

              return (
                <CobranzaConciliacionClientesCell
                  key={index}
                  cobranzaItem={cobranzaItem}
                  interestItems={interesesItems}
                  index={index}
                  toggleDetails={toggleDetails}
                  abonarCliente={abonarCliente}
                  abonarProducto={abonarProducto}
                  tDetalleRef={tDetalleRef}
                  tDetalleIsShownRef={tDetalleIsShownRef}
                />
              );
            })}

          {/*!isLoading && interesesItems && (
            <CobranzaConciliacionClientesCell
              interestItems={interesesItems}
              toggleDetails={toggleDetails}
              abonarCliente={abonarCliente}
              abonarProducto={abonarProducto}
              tDetalleRef={tDetalleRef}
              tDetalleIsShownRef={tDetalleIsShownRef}
            />
          )*/}
        </tbody>
      </table>
    </div>
  );
}
